import { useContext } from "react";
import { UserContext } from "../../Context/UserContextAPI";
import formatDate from "../../utils/formatDate";

const UserTableInReport = ({ user }) => {
  const { settingsData } = useContext(UserContext);
  const currentYear = new Date().getFullYear();
  const birthYear = user?.date_of_birth
    ? new Date(user?.date_of_birth).getFullYear()
    : null;
  const age = birthYear ? `${currentYear - birthYear}Y` : "";
  return (
    <div className="row justify-content-center h-100">
      <div className="col-sm-2">
        <div
          className="pres-photo border border-end-0 border-dark"
          style={{ width: "100%", height: "114px" }}
        >
          {user?.image ? (
            <img
              src={`${process.env.REACT_APP_UPLOAD_URL}/users/${user?.image}`}
              className="img-fluid"
              alt="patient"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <img
              src="./dummy.jpg"
              alt="patient"
              className="img-fluid"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </div>
        <p
          className="pres-title p-0 m-0 w-100 border border-end-0 border-top-0 border-dark text-center fw-bold d-flex align-items-center justify-content-center text-dark"
          style={{ height: "29px" }}
        >
          PHOTO
        </p>
      </div>
      <div className="col-sm-8">
        <div className="row h-100 text-dark">
          <table
            className="responsive-width1 table-bordered"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <tbody>
              {/* Row 1 - Name and Client ID */}
              <tr>
                <td
                  className="text-uppercase border border-dark ps-1 align-middle"
                  style={{ width: "25%" }}
                >
                  Name
                </td>
                <td
                  className="text-uppercase border border-dark ps-1 align-middle"
                  style={{ width: "25%" }}
                >
                  {user?.f_name || "---"}
                </td>
                <td
                  className="text-uppercase border border-dark ps-1 align-middle"
                  style={{ width: "25%" }}
                >
                  Client ID
                </td>
                <td
                  className="text-uppercase border border-dark ps-1 align-middle"
                  style={{ width: "25%" }}
                >
                  {user?.reg_prefix || ""}
                  {user?.registration_no || "---"}
                </td>
              </tr>

              {/* Row 2 - Gender and Passport No */}
              <tr>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  Gender
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {user?.userDetail?.gender?.name || "---"}
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  Passport No
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {user?.passport_no || "---"}
                </td>
              </tr>

              {/* Row 3 - Date of Birth and Travelling To */}
              <tr>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  Date of Birth
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {formatDate(user?.date_of_birth) || "---"} {age && `(${age})`}
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  Country
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {user?.userDetail?.country?.name || "---"}
                </td>
              </tr>

              {/* Row 4 - Father Name and Contact Number */}
              <tr>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  Marital Status
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {user?.userDetail?.marital_status?.name || "---"}
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  Contact Number
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {settingsData?.mobile_show_in_report === 1
                    ? user?.mobile || ""
                    : "---"}
                </td>
              </tr>

              {/* Row 5 - Nationality and Agency */}
              <tr>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  Nationality
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {user?.userDetail?.national_country?.nationality || "---"}
                </td>
                <td className="text-uppercase border border-dark ps-1 align-middle">
                  {settingsData?.introducer_label}
                </td>
                <td
                  className="text-uppercase border border-dark ps-1 align-middle"
                  colSpan={3}
                >
                  {user?.userDetail?.introducer_user?.f_name || "---"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-sm-2 h-100">
        <div
          className="pres-photo border border-start-0 border-dark"
          style={{ width: "100%", height: "114px" }}
        >
          {user?.finger_print ? (
            <img
              src={`${process.env.REACT_APP_UPLOAD_URL}/users/${user?.finger_print}`}
              className="img-fluid"
              alt=""
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <div
              className="p-0 border border-start-0 text-center report-avatar text-dark d-flex align-items-center justify-content-center"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
            >
              No Fingerprint Found
            </div>
          )}
        </div>
        <p
          className="pres-title p-0 m-0 w-100 border border-top-0 border-start-0 border-dark text-center fw-bold d-flex align-items-center justify-content-center text-dark"
          style={{ height: "29px" }}
        >
          THUMB PRINT
        </p>
      </div>
    </div>
  );
};
export default UserTableInReport;
